import Vue from 'vue'
import VueRouter from 'vue-router'
import mainRouter from '@/router/mainRouter/mainRouter'
import loginRouter from '@/router/mainLogin/login'
Vue.use(VueRouter)

const routes = [...loginRouter, ...mainRouter]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
const routerPush = VueRouter.prototype.push
const routerReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error)
}
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch((error) => error)
}
router.beforeEach((to, from, next) => {
  let token = window.sessionStorage.getItem('token')
  let is_xiaopai = window.sessionStorage.getItem('is_xiaopai')
  if (to.query.token) {
    token = to.query.token
    window.sessionStorage.setItem('token', token)
  }
  // 没有任何登录信息返回登录页
  if (!token && !is_xiaopai && to.name != 'login') {
    next('/')
    // 不是总账号登录不让进总账号管理页
  } else if (!is_xiaopai && to.path == '/openAccount') {
    next('/')
    // 总账号登录且不是总账号管理页
  } else if (is_xiaopai && !token && to.path != '/openAccount') {
    next('/openAccount')
  } else if (token && to.path == '/') {
    next('/index')
  } else {
    next()
  }
})

export default router
